import { Accordion, AccordionTab } from "primereact/accordion";
import "../../css/Accordion.css";
import { FC } from "react";
import { CustomAccordionInterface } from "app/utils/types";

const CustomAccordion: FC<CustomAccordionInterface> = ({
  header,
  content,
  className,
  isPendingProposal = true,
  activeIndex = 0,
  onTabOpen,
}) => (
  <Accordion
    activeIndex={activeIndex}
    onTabOpen={onTabOpen}
    className={`${isPendingProposal ? " pending-proposals " : ""} ${className}  `}
  >
    <AccordionTab header={header}>{content}</AccordionTab>
  </Accordion>
);
export default CustomAccordion;
